import { IHideTripCost } from '../../domain/entities/settings-entity';
import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.hide_trip_cost`. */
export const editHideTripCost = async (hide_trip_cost: IHideTripCost): Promise<any> =>
  writeSettingsFields({ hide_trip_cost });
